import * as D from 'io-ts/lib/Decoder'

type UnpopulatedData<T> = T extends any[] ? string[] : string

export type Unpopulated<T, K extends keyof T> = Omit<T, K> & { [P in K]: UnpopulatedData<T[K]> }

export const populated = <T>(decoder: D.Decoder<T>): D.Decoder<T | string> => D.union(decoder, D.string)

export const populatedArray = <T>(decoder: D.Decoder<T>): D.Decoder<T[] | string[]> =>
    D.union(D.array(decoder), D.array(D.string))
